import React from "react";

function SvgIcMapPoi071(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M26 13h-4V8a1 1 0 00-1-1H6a1 1 0 00-1 1v14c0 1.203 3 2 3 2h.5c0-.108.006-.216.016-.322l.012-.105c.009-.07.02-.14.032-.21l.024-.12c.015-.064.031-.127.049-.189.011-.039.021-.079.033-.118.028-.087.06-.172.095-.256.021-.054.047-.107.071-.159.017-.036.034-.073.052-.108a2.55 2.55 0 01.089-.162c.016-.029.035-.058.052-.086.035-.056.069-.111.106-.165h.001a3.514 3.514 0 011.074-1H7V9h13v12h-6.207c.425.255.792.595 1.075 1 .037.054.071.109.107.165.017.028.035.057.051.086.032.053.061.107.089.162.019.035.035.072.052.108.024.052.05.105.072.159.034.084.066.169.094.256.013.039.022.079.033.118.018.062.034.125.049.189A3.813 3.813 0 0115.5 24h5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5h.5v-8l-2-3zm-12 2h-2v-1.999h2c.806 0 .988.549.999.999 0 .301-.097 1-.999 1m10 7.5a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0124 22.5zm-12 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0112 22.5zM10 11h4c2.2 0 3 1.793 3 3 0 1.164-.746 2.878-2.777 2.995L14 17h-2V19h-2v-8h4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi071;
